import React, { useEffect } from "react";

import { checkApplicationStatus } from "EmployerApplication/Actions";
import { setDisplayedApplicationReminders, useGetCurrentCompanyApplicationQuery } from "EmployerApplication/api";
import { default as ApplicationStatus } from "EmployerApplication/Components/ApplicationStatusPage";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const ApplicationStatusPage = ({ dispatchApplicationStatus, setDisplayedApplicationReminders }) => {
  const { data: companyApplication } = useGetCurrentCompanyApplicationQuery();
  const companyPolicyId = companyApplication?.id;

  // TODO Both of these should only be called once ever instead of per render of this component, but no harm
  // since the endpoints are idempotent.
  useEffect(() => {
    dispatchApplicationStatus();
  }, []);
  useEffect(() => {
    if (!companyPolicyId) return;
    setDisplayedApplicationReminders(companyPolicyId);
  }, [companyPolicyId]);

  const selectApplicationState = () => {
    return <ApplicationStatus />;
  };

  return <>{selectApplicationState()}</>;
};

const mapDispatchToProps = (dispatch) => ({
  // Note - checkApplicationStatus doesn't get the status from the backend and store it
  // on the frontend for this page to use. It actually triggers the backend to check the
  // status and send analytics events (like creating an opportunity in salesforce).
  dispatchApplicationStatus: () => {
    dispatch(checkApplicationStatus());
  },
  setDisplayedApplicationReminders: (companyPolicyId) => {
    dispatch(setDisplayedApplicationReminders(companyPolicyId));
  },
});

export default withRouter(connect(null, mapDispatchToProps)(ApplicationStatusPage));
